import styled from 'styled-components';
import { media } from 'utils/style';

import AddressSuggestionsSelector from 'components/AddressModal/components/AddressSuggestionsSelector/container';

export default styled(AddressSuggestionsSelector)`
  width: 450px;
  max-width: 100%;
  max-height: 270px;
  overflow-y: auto;

  .suggestion-separator {
    margin: 0 5%;
    border: solid 0.5px var(--grey300);
  }

  ${media.lessThan('extraSmall')`
    max-height: 100%;
  `}
`;
